import React from 'react';
import { Button } from '~/native-ui';


export const SpinnerButton = React.forwardRef(({ icon, ...props }, ref) => {
    let isLoading = false;
    if(icon === 'spinning') {
        icon = undefined;
        isLoading = true;
    }

    return (
        <Button ref={ref} {...props} icon={ icon } isLoading={isLoading} />
    );
});